import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, Fragment as _Fragment, resolveDynamicComponent as _resolveDynamicComponent } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "reference-component__desc"
}
const _hoisted_2 = ["href"]
const _hoisted_3 = { class: "reference-component__link" }
const _hoisted_4 = {
  key: 0,
  class: "reference-component__desc"
}
const _hoisted_5 = ["href"]
const _hoisted_6 = ["innerHTML"]
const _hoisted_7 = {
  key: 0,
  class: "reference-component__desc"
}
const _hoisted_8 = ["href"]
const _hoisted_9 = { class: "reference-component__link" }
const _hoisted_10 = { class: "reference-component__desc" }
const _hoisted_11 = ["href"]
const _hoisted_12 = { class: "reference-component__link" }
const _hoisted_13 = {
  key: 0,
  class: "reference-component__desc"
}
const _hoisted_14 = ["href"]
const _hoisted_15 = { class: "reference-component__link" }
const _hoisted_16 = {
  key: 0,
  class: "reference-component__desc"
}
const _hoisted_17 = ["href"]
const _hoisted_18 = { class: "reference-component__link" }
const _hoisted_19 = ["href"]
const _hoisted_20 = { class: "reference-component__link" }
const _hoisted_21 = {
  key: 1,
  class: "reference-component__desc"
}
const _hoisted_22 = {
  key: 2,
  class: "reference-component__desc"
}
const _hoisted_23 = ["href"]
const _hoisted_24 = { class: "reference-component__link" }
const _hoisted_25 = {
  key: 0,
  class: "reference-component__desc"
}
const _hoisted_26 = { key: 10 }
const _hoisted_27 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_UserReferenceTooltip = _resolveComponent("UserReferenceTooltip")!
  const _component_FileReferenceComponent = _resolveComponent("FileReferenceComponent")!
  const _component_Attachment = _resolveComponent("Attachment")!

  return (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.nodeViewWrapper), {
    id: _ctx.initFileInstance.id,
    class: _normalizeClass([
      'reference-component-wrap',
      { 'reference-component-wrap_custom': _ctx.type === _ctx.referenceTypes.FILE }
    ])
  }, {
    default: _withCtx(() => [
      _createElementVNode("span", {
        class: _normalizeClass([
        'reference-component',
        `reference-component_${_ctx.type.toLowerCase()}`,
        { 'is-deleted': _ctx.type === _ctx.referenceTypes.IDEA && _ctx.info?.deleted }
      ])
      }, [
        (!_ctx.isShowLoading)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              (_ctx.type === _ctx.referenceTypes.USER || _ctx.type === _ctx.referenceTypes.PREVIOUS_TASK_OWNER)
                ? (_openBlock(), _createBlock(_component_UserReferenceTooltip, {
                    key: 0,
                    user: _ctx.info
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", {
                        class: "is-flex",
                        onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["prevent"]))
                      }, [
                        _createElementVNode("span", {
                          class: _normalizeClass(["reference-component__link", [{ 'is-disabled': _ctx.info.enabled === false }]])
                        }, _toDisplayString(_ctx.text), 3),
                        (_ctx.isShowDetails)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_1, " (" + _toDisplayString(_ctx.info.email) + ") ", 1))
                          : _createCommentVNode("", true)
                      ])
                    ]),
                    _: 1
                  }, 8, ["user"]))
                : _createCommentVNode("", true),
              (_ctx.type === _ctx.referenceTypes.ITEM)
                ? (_openBlock(), _createElementBlock("a", {
                    key: 1,
                    class: "is-grid",
                    href: _ctx.href ? _ctx.href : '#',
                    target: "_blank",
                    onMousedown: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["prevent"]))
                  }, [
                    _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.text), 1),
                    (_ctx.info?.itemTypeParsed?.label)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_4, " (" + _toDisplayString(_ctx.info.itemTypeParsed.label) + ", " + _toDisplayString(_ctx.info?.statusParsed?.label) + ") ", 1))
                      : _createCommentVNode("", true)
                  ], 40, _hoisted_2))
                : (_ctx.type === _ctx.referenceTypes.TASK)
                  ? (_openBlock(), _createElementBlock("a", {
                      key: 2,
                      class: "is-flex",
                      href: _ctx.href ? _ctx.href : '#',
                      target: "_blank",
                      onMousedown: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["prevent"]))
                    }, [
                      _createElementVNode("span", {
                        class: "reference-component__link",
                        innerHTML: _ctx.text
                      }, null, 8, _hoisted_6),
                      (_ctx.taskReferenceDescription)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_7, " (" + _toDisplayString(_ctx.taskReferenceDescription) + ")", 1))
                        : _createCommentVNode("", true)
                    ], 40, _hoisted_5))
                  : (_ctx.type === _ctx.referenceTypes.MILESTONE)
                    ? (_openBlock(), _createElementBlock("a", {
                        key: 3,
                        class: "is-flex",
                        href: _ctx.href ? _ctx.href : '#',
                        target: "_blank",
                        onMousedown: _cache[3] || (_cache[3] = _withModifiers(() => {}, ["prevent"]))
                      }, [
                        _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.text), 1),
                        _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.formattedDateStart) + " - " + _toDisplayString(_ctx.formattedDateEnd), 1)
                      ], 40, _hoisted_8))
                    : (_ctx.type === _ctx.referenceTypes.EPIC)
                      ? (_openBlock(), _createElementBlock("a", {
                          key: 4,
                          class: "is-flex",
                          href: _ctx.href ? _ctx.href : '#',
                          target: "_blank",
                          onMousedown: _cache[4] || (_cache[4] = _withModifiers(() => {}, ["prevent"]))
                        }, [
                          _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.text), 1),
                          (_ctx.info?.percentComplete)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_13, _toDisplayString(_ctx.info.percentComplete) + "% Done ", 1))
                            : _createCommentVNode("", true)
                        ], 40, _hoisted_11))
                      : (_ctx.type === _ctx.referenceTypes.IDEA)
                        ? (_openBlock(), _createElementBlock("a", {
                            key: 5,
                            class: "is-flex",
                            href: _ctx.href ? _ctx.href : '#',
                            target: "_blank",
                            onMousedown: _cache[5] || (_cache[5] = _withModifiers(() => {}, ["prevent"]))
                          }, [
                            _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.text), 1),
                            (_ctx.ideaReferenceDescription)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_16, " (" + _toDisplayString(_ctx.ideaReferenceDescription) + ") ", 1))
                              : _createCommentVNode("", true)
                          ], 40, _hoisted_14))
                        : (_ctx.type === _ctx.referenceTypes.PROJECT)
                          ? (_openBlock(), _createElementBlock("a", {
                              key: 6,
                              href: _ctx.href ? _ctx.href : '#',
                              target: "_blank",
                              onMousedown: _cache[6] || (_cache[6] = _withModifiers(() => {}, ["prevent"]))
                            }, [
                              _createElementVNode("span", _hoisted_18, _toDisplayString(_ctx.text), 1)
                            ], 40, _hoisted_17))
                          : (_ctx.type === _ctx.referenceTypes.SPRINT)
                            ? (_openBlock(), _createElementBlock("a", {
                                key: 7,
                                class: "is-flex",
                                href: _ctx.href ? _ctx.href : '#',
                                target: "_blank",
                                onMousedown: _cache[7] || (_cache[7] = _withModifiers(() => {}, ["prevent"]))
                              }, [
                                (_ctx.info?.status)
                                  ? (_openBlock(), _createElementBlock("span", {
                                      key: 0,
                                      class: _normalizeClass(["dot dot_sm reference-component__meta", [`is-${_ctx.info.status.toLowerCase()}`]])
                                    }, null, 2))
                                  : _createCommentVNode("", true),
                                _createElementVNode("span", _hoisted_20, _toDisplayString(_ctx.text), 1),
                                (_ctx.info?.startDate)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_21, _toDisplayString(_ctx.formattedDateStart) + " - " + _toDisplayString(_ctx.formattedDateEnd), 1))
                                  : _createCommentVNode("", true),
                                (_ctx.info?.team?.name)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_22, " (Team " + _toDisplayString(_ctx.info.team.name) + ") ", 1))
                                  : _createCommentVNode("", true)
                              ], 40, _hoisted_19))
                            : (_ctx.type === _ctx.referenceTypes.TEAM)
                              ? (_openBlock(), _createElementBlock("a", {
                                  key: 8,
                                  class: "is-flex",
                                  href: _ctx.href ? _ctx.href : '#',
                                  target: "_blank",
                                  onMousedown: _cache[8] || (_cache[8] = _withModifiers(() => {}, ["prevent"]))
                                }, [
                                  _createElementVNode("span", _hoisted_24, _toDisplayString(_ctx.text), 1),
                                  (_ctx.info?.size)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_25, " (" + _toDisplayString(_ctx.info.size) + ") ", 1))
                                    : _createCommentVNode("", true)
                                ], 40, _hoisted_23))
                              : (_ctx.type === _ctx.referenceTypes.FILE_LINK)
                                ? (_openBlock(), _createBlock(_component_FileReferenceComponent, {
                                    key: 9,
                                    node: _ctx.node,
                                    editor: _ctx.editor,
                                    updateAttributes: _ctx.updateAttributes,
                                    getPos: _ctx.getPos
                                  }, null, 8, ["node", "editor", "updateAttributes", "getPos"]))
                                : (_ctx.type === _ctx.referenceTypes.FILE)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                                      _createVNode(_component_Attachment, {
                                        node: _ctx.node,
                                        editor: _ctx.editor,
                                        updateAttributes: _ctx.updateAttributes,
                                        getPos: _ctx.getPos
                                      }, null, 8, ["node", "editor", "updateAttributes", "getPos"])
                                    ]))
                                  : _createCommentVNode("", true)
            ], 64))
          : (_openBlock(), _createElementBlock("span", _hoisted_27, "...Loading..."))
      ], 2)
    ]),
    _: 1
  }, 8, ["id", "class"]))
}